"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentProvider = void 0;
var PaymentProvider;
(function (PaymentProvider) {
    PaymentProvider["Mangopay"] = "Mangopay";
    PaymentProvider["Checkout"] = "Checkout";
    PaymentProvider["Stripe"] = "Stripe";
})(PaymentProvider || (exports.PaymentProvider = PaymentProvider = {}));
//# sourceMappingURL=PaymentProvider.js.map